import { type MyonEnv, isEnvUserAuthorized } from "shared/Api/MyonEnv";
import { PermissionType } from "shared/Api/PermissionType";
import { Role } from "shared/Api/Role";

export class PermissionService {

	private permissionIds: number[] = [];

	constructor(
		private env: MyonEnv
	) {
		if (isEnvUserAuthorized(this.env)) {
			this.permissionIds = this.env.auth.permissionIds;
		}
	}

	public hasLexileMetrics(): boolean {
		return this.anyPermissionIds(
			PermissionType.LEGACY_LEXILE,
			PermissionType.LEGACY_STAR,
			PermissionType.METAMETRICS_LEXILE,
			PermissionType.LEXILE_DISPLAY
		);
	}

	public hasMyList(): boolean {
		const role = isEnvUserAuthorized(this.env) ? this.env.auth.roleId : null;
		return !(role == Role.FACULTY && this.isSharedLogin());
	}

	public isSharedLogin(): boolean {
		return this.hasPermissionIds(PermissionType.SHARED_LOGIN);
	}

	private anyPermissionIds(...permissionIds: number[]): boolean {
		return permissionIds.some(id => this.hasPermissionId(id));
	}

	private hasPermissionId(permissionId: number): boolean {
		return this.permissionIds.indexOf(permissionId) >= 0;
	}

	private hasPermissionIds(...permissionIds: number[]): boolean {
		return permissionIds.every(id => this.hasPermissionId(id));
	}

}
